import TabsSlider from 'components/TabsSlider';
import includes from 'lodash/includes';
import moment from 'moment';
import React, { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import placeholder from '../../assets/images/placeholder.jpg';
import { selectStoreConfig } from '../../containers/Layout/selectors';
import { getMenuItemForInstore } from '../../helpers/getMenuItemForInstore';
import NewMenuItem from '../NewMenuItem';
import swiperNew from './mainNew';
// import { useLocation } from 'react-router-dom';

const weekdays = {
  1: `Monday`,
  2: `Tuesday`,
  3: `Wednesday`,
  4: `Thursday`,
  5: `Friday`,
  6: `Saturday`,
  7: `Sunday`,
};

export default function MenuItems({
  halfView,
  halfItem,
  hhActiveMenuSizes,
  showSpecialsHandler,
  showHalfViewHandler,
  showMenuItemHandler,
  showSpecialItem,
  showHalfItem,
  history,
  location,
  itemVariants,
  selectedHalfItems,
  // initiateDesktopLoyaltyFlow,
}) {
  const [state, setLocalState] = useReducer((s, a) => ({ ...s, ...a }), {
    filteredCategories: [],
    categories: [],
    populars: [],
  });
  const { halfHalfSetup } = useSelector((state) => state.layoutReducer);
  const storeConfig = useSelector(selectStoreConfig);
  const {
    populars,
    categories,
    allSpecials,
    menuItems,
    menuItemSizes,
    menuItemSubModifiers,
    currentOrder,
    orderSetup,
    specialFilter: {
      isSpecialFilterApplied,
      spMenuItems,
      spMenuSizes,
      spSubModifiers,
      spMenuCategories,
    },
  } = useSelector((state) => state.homeReducer);

  useEffect(() => {
    swiperNew();
    updateState();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateState();
    // eslint-disable-next-line
  }, [
    categories,
    populars,
    menuItems,
    currentOrder,
    halfItem,
    halfView,
    hhActiveMenuSizes,
    isSpecialFilterApplied,
    itemVariants,
    menuItemSizes,
    menuItemSubModifiers,
    selectedHalfItems,
    spMenuCategories,
    spMenuItems,
    spMenuSizes,
    spSubModifiers,
  ]);

  const updateState = () => {
    // Filter for special categories
    if (categories && menuItems && currentOrder) {
      let newCategories = categories.map((m) => {
        m.menuItems = menuItems.filter((a) => {
          return (
            a.categoryId === m._id &&
            a.orderFromKeys.includes('1') &&
            a.orderTypeKeys.includes(currentOrder.orderType) &&
            a.isPublished
          );
        });

        // fetch in-store prices for menu items
        m.menuItems.map((menuItem) => {
          if (
            menuItem.orderFromKeys.includes('2') &&
            menuItem.orderTypeKeys.includes(currentOrder.orderType) &&
            menuItem.isPublished &&
            (menuItemSizes?.length || menuItemSubModifiers?.length)
          ) {
            const newMenuItemSizes = menuItemSizes.filter(
              (f) =>
                f.orderType === currentOrder.orderType &&
                f.menuItemId === menuItem._id
            );
            const newMenuItemSubModifiers = menuItemSubModifiers.filter(
              (f) =>
                f.orderType === currentOrder.orderType &&
                f.menuItemId === menuItem._id
            );
            return getMenuItemForInstore(
              menuItem,
              newMenuItemSizes,
              newMenuItemSubModifiers
            );
          } else {
            return menuItem;
          }
        });

        return m;
      });

      let items = [];
      if (isSpecialFilterApplied && !halfView) {
        items = newCategories.filter((obj) => {
          return spMenuCategories
            .filter((f) => f.isActive)
            .map((m) => m._id)
            .includes(obj._id);
        });
        items.map((item) => {
          item.filteredMenuItems = item.menuItems.filter((obj) => {
            let i = 0;
            if (
              spMenuItems &&
              spMenuItems.length > 0 &&
              ((spMenuSizes && spMenuSizes.length > 0) ||
                (spSubModifiers && spSubModifiers.length > 0))
            ) {
              let matchedItems = spMenuItems.filter((item) => {
                return obj._id === item._id;
              });
              if (matchedItems.length > 0) {
                if (matchedItems[0].isActive) {
                  obj.selectedSizes.map((m) => {
                    spMenuSizes &&
                      spMenuSizes.length > 0 &&
                      spMenuSizes.map((c) => {
                        if (c._id === m._id && c.isActive) i++;
                        return c;
                      });
                    spSubModifiers &&
                      spSubModifiers.length > 0 &&
                      spSubModifiers.map((c) => {
                        if (c._id === m._id && c.isActive) i++;
                        return c;
                      });
                    return m;
                  });
                  if (matchedItems[0].price) obj.upsale = matchedItems[0].price;
                }
              } else {
                obj.selectedSizes.map((m) => {
                  spMenuSizes &&
                    spMenuSizes.length > 0 &&
                    spMenuSizes.map((c) => {
                      if (c._id === m._id && c.isActive) i++;
                      return c;
                    });
                  spSubModifiers &&
                    spSubModifiers.length > 0 &&
                    spSubModifiers.map((c) => {
                      if (c._id === m._id && c.isActive) i++;
                      return c;
                    });
                  return m;
                });
                obj.upsale = 0;
              }
            }
            obj.showName = !obj.isNameHidden;
            return i !== 0;
          });
          return item;
        });
      }

      // Filter for half half view
      if (halfView && halfItem && halfItem.categories && hhActiveMenuSizes) {
        const addedKeys = selectedHalfItems.map((m) => m._id);
        items = newCategories.filter((obj) => {
          return halfItem.categories.map((m) => m._id).includes(obj._id);
        });
        items.map((item) => {
          item.filteredMenuItems = item.menuItems.filter((obj) => {
            let i = 0,
              mnt = 0;
            obj.selectedSizes.map((m) => {
              if (itemVariants && itemVariants.length > 0) {
                if (hhActiveMenuSizes.map((mh) => mh._id).includes(m._id)) {
                  if (m.variants) {
                    let cnt = 0;
                    m.variants.map((v) => {
                      let matchingVs = itemVariants.filter((f) => {
                        return f._id === v._id && v.isSelected === true;
                      });
                      if (matchingVs.length > 0) {
                        cnt = cnt + 1;
                      }
                      return v;
                    });
                    if (cnt === itemVariants.length) i++;
                  }
                }
              } else {
                hhActiveMenuSizes.map((mh) => mh._id).includes(m._id) && i++;
              }
              return m;
            });
            if (halfItem.menuItems) {
              let matchingMs = halfItem.menuItems.filter((m) => {
                return m._id === obj._id;
              });
              if (matchingMs.length > 0) {
                if (matchingMs[0].isActive) mnt = mnt + 1;
              } else mnt = mnt + 1;
            }
            obj.showName = !obj.isNameHidden;
            return (
              i !== 0 &&
              !includes(addedKeys, obj._id) &&
              ((halfItem.menuItems && mnt !== 0) ||
                (!halfItem.menuItems && mnt === 0))
            );
          });
          return item;
        });
      }
      setLocalState({
        categories: newCategories,
        filteredCategories: items,
      });
    }
    if (populars && currentOrder) {
      let newPopulars = populars.filter(
        (f) =>
          f.orderFromKeys.includes('1') &&
          f.orderTypeKeys.includes(currentOrder.orderType) &&
          f.isPublished
      );

      newPopulars = populars.map((popular) => {
        if (
          popular.orderFromKeys.includes('2') &&
          popular.orderTypeKeys.includes(currentOrder.orderType) &&
          popular.isPublished &&
          (menuItemSizes?.length || menuItemSubModifiers?.length)
        ) {
          const newMenuItemSizes = menuItemSizes.filter(
            (f) =>
              f.orderType === currentOrder.orderType &&
              f.menuItemId === popular._id
          );
          const newMenuItemSubModifiers = menuItemSubModifiers.filter(
            (f) =>
              f.orderType === currentOrder.orderType &&
              f.menuItemId === popular._id
          );
          return getMenuItemForInstore(
            popular,
            newMenuItemSizes,
            newMenuItemSubModifiers
          );
        }
        return popular;
      });

      setLocalState({ populars: newPopulars });
    }
  };

  // const getPriceForDisplay = (item) => {
  //   if (item.selectedSizes && item.selectedSizes.length > 0) {
  //     if (isSpecialFilterApplied && spMenuSizes) {
  //       let featureSizes = item.selectedSizes.filter((obj) => {
  //         return spMenuSizes.map((m) => m._id).includes(obj._id);
  //       });
  //       if (featureSizes.length > 0) {
  //         return (
  //           featureSizes[0].name.substring(0, 1) +
  //           ' ' +
  //           Number(featureSizes[0].price).toFixed(2)
  //         );
  //       } else return Number(item.selectedSizes[0].price).toFixed(2);
  //     } else {
  //       let featureSizes = item.selectedSizes.filter((obj) => {
  //         return obj.isFeaturedSize === true;
  //       });
  //       if (featureSizes.length > 0) {
  //         return featureSizes[0].isAbbreviationShow
  //           ? featureSizes[0].name.substring(0, 1) +
  //               ' ' +
  //               Number(featureSizes[0].price).toFixed(2)
  //           : Number(featureSizes[0].price).toFixed(2);
  //       } else return Number(item.selectedSizes[0].price).toFixed(2);
  //     }
  //   } else {
  //     if (item.isAvailable) return '';
  //     else return 'Sold Out';
  //   }
  // };

  const renderSpinner = () => {
    return (
      <div className='loadBoxWrap' style={{ padding: '19px 14px 0px' }}>
        {[...Array(15)].map((_, index) => {
          return (
            <div className='loadPlace itemBoxes' key={index}>
              <div>
                <img src={placeholder} alt='Loading' />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderMenuItems = () => {
    if (isSpecialFilterApplied && !halfView) {
      return (
        <CSSTransition
          key={2}
          classNames='example'
          timeout={{ enter: 0, exit: 0 }}
          component='div'
        >
          <div
            className='itemWrap2 tabsSlider--tabsWrapper'
            key='2'
            data-id='2'
            style={{ paddingTop: '26px' }}
          >
            <div className='catFil' key='2'>
              {state.filteredCategories &&
                state.filteredCategories.length > 0 &&
                state.filteredCategories.map((filterSPCat) => {
                  let list = filterSPCat.filteredMenuItems;

                  let matchingHalfCategories = [];

                  if (halfHalfSetup) {
                    matchingHalfCategories = halfHalfSetup.halfHalfs.filter(
                      (item) => {
                        return item.categories
                          .map((c) => c._id)
                          .includes(filterSPCat._id);
                      }
                    );
                  }

                  if (matchingHalfCategories.length > 0) {
                    let obj = {};
                    obj.history = history;
                    obj.location = location;
                    obj.itemType = 'halfhalf';
                    obj.item = matchingHalfCategories[0];
                    obj.displayOrder = -1;
                    obj.totalRevenue = 1000000000000;
                    obj.lazyLoad = false;
                    obj.itemHandler = showHalfViewHandler;
                    obj.urlS3 = halfHalfSetup.halfHalfPlaceholderImage
                      ? halfHalfSetup.halfHalfPlaceholderImage
                      : `https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/placeholder.jpg`;
                    obj.key = `halhalk23set`;
                    obj.showName = true;
                    obj.name = `HALF / HALF`;

                    const activeSizes = spMenuSizes?.filter(
                      ({ isActive }) => isActive
                    );
                    const activeSubModifiers = spSubModifiers?.filter(
                      ({ isActive }) => isActive
                    );

                    const selectedSizes = obj.item.selectedSizes.filter(
                      ({ isActive, _id }) =>
                        isActive &&
                        activeSizes.findIndex((s) => s._id === _id) !== -1
                    );

                    const selectedModifiers = obj.item.selectedModifiers.filter(
                      ({ isActive, _id }) =>
                        isActive &&
                        activeSubModifiers.findIndex((s) => s._id === _id) !==
                          -1
                    );

                    const defaultSizes = obj.item.defaultSizes.filter(
                      ({ isActive, _id }) =>
                        isActive &&
                        (activeSizes.findIndex((s) => s._id === _id) !== -1 ||
                          activeSubModifiers.findIndex((s) => s._id === _id) !==
                            -1)
                    );

                    if (defaultSizes.length) {
                      list = [
                        {
                          ...obj,
                          ...obj.item,
                          selectedModifiers,
                          selectedSizes,
                          defaultSizes,
                        },
                        ...list,
                      ];
                    }
                  }

                  return list.map((item, idx) => (
                    <React.Fragment key={`sp-${item._id}-${idx}`}>
                      <NewMenuItem
                        key={`sp-${item._id}`}
                        history={history}
                        location={location}
                        itemType='specialitem'
                        category={filterSPCat}
                        item={item}
                        productName={item.name}
                        lazyLoad={false}
                        bgImgSrc={item.urlS3 ? item.urlS3 : item.url}
                        ingredients={
                          item.description &&
                          item.description.length >
                            (window.innerWidth > 340 ? 40 : 25)
                            ? item.description
                                .substr(0, window.innerWidth > 340 ? 36 : 25)
                                .substr(
                                  0,
                                  Math.min(
                                    item.description.substr(
                                      0,
                                      window.innerWidth > 340 ? 36 : 25
                                    ).length,
                                    item.description
                                      .substr(
                                        0,
                                        window.innerWidth > 340 ? 36 : 25
                                      )
                                      .lastIndexOf(' ')
                                  )
                                ) + '...'
                            : item.description
                        }
                        imgSrc='https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/placeholder.jpg'
                        itemHandler={
                          item.itemType === 'halfhalf'
                            ? showHalfViewHandler
                            : showSpecialItem
                        }

                        // price={getPriceForDisplay(item)} // ⛔️ Not Used
                        // initiateDesktopLoyaltyFlow={initiateDesktopLoyaltyFlow} // ⛔️ Not Used
                      />
                    </React.Fragment>
                  ));
                })}
            </div>
          </div>
        </CSSTransition>
      );
    } else if (halfView) {
      const halfItemIds = halfItem.menuItems
        .filter((i) => i.isActive)
        .map((i) => i._id);
      const defaultPairId =
        hhActiveMenuSizes && hhActiveMenuSizes[0]?.pairId
          ? hhActiveMenuSizes[0].pairId
          : halfItem.defaultSizes[0].pairId;

      const sizeIds = [
        ...halfItem.selectedSizes.filter(
          ({ pairId }) => pairId === defaultPairId
        ),
        ...halfItem.selectedModifiers.filter(
          ({ pairId }) => pairId === defaultPairId
        ),
      ].map((i) => i._id);

      const variantIds = itemVariants.map((i) => i._id);

      const items = menuItems
        .filter((i) => {
          const halfPredicate = halfItemIds.includes(i._id);
          const { itemType, selectedSizes, selectedModifiers } = i;
          const size =
            itemType === 0
              ? selectedSizes.find((s) => sizeIds.includes(s._id))
              : selectedModifiers
                  .flatMap((m) => m.subModifiers.filter((sm) => sm.isAvailable))
                  .find((i) => sizeIds.includes(i._id));

          const variantsPredicate =
            variantIds.length > 0 && size && Array.isArray(size.variants)
              ? size.variants.some(
                  (v) =>
                    v.isSelected && v.isAvailable && variantIds.includes(v._id)
                )
              : true;

          return halfPredicate && !!size && variantsPredicate;
        })
        ?.sort((a, b) => a?.categoryId.localeCompare(b?.categoryId));

      return (
        <CSSTransition
          key={3}
          classNames='example'
          timeout={{ enter: 500, exit: 0 }}
          component='div'
        >
          <div
            key='3'
            data-id='3'
            style={{
              paddingTop: '26px',
              flex: '1 1 100%',
              height: '100%',
              width: '100%',
            }}
          >
            <div className='catFil' key='3'>
              {items.map((item, idx) => (
                <React.Fragment key={`${item._id}-${idx}`}>
                  <NewMenuItem
                    key={item._id}
                    history={history}
                    location={location}
                    itemType='halfhalfitem'
                    item={item}
                    lazyLoad={false}
                    itemHandler={showHalfItem}
                    imgSrc='https://s3-ap-southeast-2.amazonaws.com/lacampa/assets/placeholder.jpg'
                    bgImgSrc={item.urlS3 ? item.urlS3 : item.url}
                    productName={item.name}
                    ingredients={
                      item.description &&
                      item.description.length >
                        (window.innerWidth > 340 ? 40 : 25)
                        ? item.description
                            .substr(0, window.innerWidth > 340 ? 36 : 25)
                            .substr(
                              0,
                              Math.min(
                                item.description.substr(
                                  0,
                                  window.innerWidth > 340 ? 36 : 25
                                ).length,
                                item.description
                                  .substr(0, window.innerWidth > 340 ? 36 : 25)
                                  .lastIndexOf(' ')
                              )
                            ) + '...'
                        : item.description
                    }
                    // initiateDesktopLoyaltyFlow={initiateDesktopLoyaltyFlow} // ⛔️ Not Used
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
        </CSSTransition>
      );
    } else {
      // regular items
      return null;
    }
  };

  const specialsTitle = orderSetup?.customSpecialTitle || 'specials';

  const tabItems = [];

  if (state.populars.length) {
    tabItems.push(
      <TabsSlider.Tab name='popular' key='mdd-popular'>
        <NewMenuItem
          key='mdd-popular'
          data={state.populars.filter(
            (f) =>
              f.orderFromKeys.includes('1') &&
              f.orderTypeKeys.includes(currentOrder.orderType) &&
              f.isPublished
          )}
          history={history}
          location={location}
          showMenuItemHandler={showMenuItemHandler}
          itemType='menuitem'

          // price={getPriceForDisplay} // ⛔️ Not Used
          // slideIndex={0} // ⛔️ Not Used
          // activeSlideIndex={slideIndex} // ⛔️ Not Used
          // initiateDesktopLoyaltyFlow={initiateDesktopLoyaltyFlow} // ⛔️ Not Used
          // soldOutMenuItems={soldOutMenuItems} // ⛔️ Not Used
        />
      </TabsSlider.Tab>
    );
  }

  const specials = allSpecials.filter(
    (f) =>
      f.orderFromKeys.includes('1') &&
      f[weekdays[moment().tz(storeConfig.timeZone).format(`E`)]] &&
      f.orderTypeKeys.includes(currentOrder.orderType) &&
      f.isPublished
  );

  if (specials?.length > 0) {
    tabItems.push(
      <TabsSlider.Tab name={specialsTitle} key='mdd-specials'>
        <NewMenuItem
          key={'mdd-special'}
          data={specials}
          history={history}
          location={location}
          showMenuItemHandler={showSpecialsHandler}
          itemType='specials'
          specialClass='specialsSlide'

          // spMenuSizes={spMenuSizes} // ⛔️ Not Used
          // isSpecialFilterApplied={isSpecialFilterApplied} // ⛔️ Not Used
          // halfHalfSetup={halfHalfSetup} // ⛔️ Not Used
          // soldOutMenuItems={soldOutMenuItems}  // ⛔️ Not Used
          // slideIndex={1} // ⛔️ Not Used
          // activeSlideIndex={slideIndex} // ⛔️ Not Used
          // initiateDesktopLoyaltyFlow={initiateDesktopLoyaltyFlow} // ⛔️ Not Used
        />
      </TabsSlider.Tab>
    );
  }

  return (
    <div className='itemWrap' style={{ height: `100%` }}>
      {state.categories?.length > 0 ? (
        <>
          {renderMenuItems()}
          <TabsSlider
            portalMenu
            containerStyle={
              isSpecialFilterApplied || halfView
                ? { display: 'none', visibility: 'hidden', opacity: 0 }
                : {}
            }
          >
            {tabItems}
            {state.categories
              ?.filter((c) => c.menuItems?.length)
              .map((category, index) => (
                <TabsSlider.Tab name={category.name} key={`mdd-${index}`}>
                  <NewMenuItem
                    key={`mdd-${index}`}
                    data={category.menuItems}
                    history={history}
                    location={location}
                    showMenuItemHandler={showMenuItemHandler}
                    showHalfViewHandler={showHalfViewHandler}
                    itemType='menuitem'
                    category={category}

                    // price={getPriceForDisplay} // ⛔️ Not Used
                    // slideIndex={index + 2} // ⛔️ Not Used
                    // activeSlideIndex={slideIndex} // ⛔️ Not Used
                    // initiateDesktopLoyaltyFlow={initiateDesktopLoyaltyFlow} // ⛔️ Not Used
                    // soldOutMenuItems={soldOutMenuItems} // ⛔️ Not Used
                  />
                </TabsSlider.Tab>
              ))}
          </TabsSlider>
        </>
      ) : (
        renderSpinner()
      )}
    </div>
  );
}
